import React from 'react';
import { usePhoneData } from '@/features/Phones/model/hooks/usePhoneData';
import { useDialogStore } from '@/features/Phones/model/store/phoneAndBooking';
import type { ButtonVariants } from '@/shared/ui/button';
import { PhoneNumberPreview } from './PhoneNumberPreview';
interface TriggerPhonePreviewProps {
  phoneNumber: string;
  btnVariants?: ButtonVariants;
  hasOnline: boolean;
  doctorId?: number;
  medcenterId?: number | null;
  onShowPhonesGtmEvent?: () => void;
  isFull?: boolean;
  className?: string;
  doctorImage: string;
  isIcon?: boolean;
}
export const TriggerPhonePreview: React.FC<TriggerPhonePreviewProps> = ({
  phoneNumber,
  btnVariants,
  hasOnline = false,
  doctorId,
  medcenterId,
  onShowPhonesGtmEvent,
  isFull = false,
  className,
  isIcon = false
}) => {
  const {
    openDialog
  } = useDialogStore();
  const {
    fetchPhoneData
  } = usePhoneData(doctorId, medcenterId);
  const handleShowPhoneClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.type === 'click') {
      if (onShowPhonesGtmEvent) {
        onShowPhonesGtmEvent();
      }
      await fetchPhoneData();
      openDialog();
    }
  };
  return <>
      <PhoneNumberPreview phoneNumber={phoneNumber} hasOnline={hasOnline} btnVariants={btnVariants} isFull={isFull} isIcon={isIcon} onShowPhoneClick={handleShowPhoneClick} className={className} data-sentry-element="PhoneNumberPreview" data-sentry-source-file="TriggerPhonePreview.tsx" />
    </>;
};